import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]
  static values = { isNew: Boolean }

  revert({ detail: { id, sourceLabel } }) {
    this.clear()

    if (this.isNewValue) {
      const label = document.querySelector(`label[for=${sourceLabel}]`)
      label.classList.remove("active")

      label.querySelector('input').checked = false
    } else {
      const label = $(`label[for=${id}]`)
      label.button("toggle")
    }
  }

  clear(event) {
    this.frameTarget.innerHTML = '';
    this.frameTarget.src = '';
  }

  show({ params: { url } }) {
    this.frameTarget.src = url
    this.frameTarget.reload()
  }
}